if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      // Se usa la ruta actual como clave única para cada colección
      this.routeKey = location.pathname;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id="' + this.dataset.section + '"]');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
      this.handleScroll = this.handleScroll.bind(this);
      // Usamos sessionStorage para persistencia en iOS
      this.storage = sessionStorage;
    }

    connectedCallback() {
      console.log('ST');
      // Verificamos si se ha marcado la preservación (clic en producto)
      const preserve = this.storage.getItem('preservePagination_' + this.routeKey);
      if (preserve === 'true') {
        // Restauramos el estado (productos y scroll) si existe
        const savedState = this.storage.getItem('paginationState_' + this.routeKey);
        if (savedState) {
          try {
            const stateObj = JSON.parse(savedState);
            this.i = stateObj.page || 2;
            this.grid.innerHTML = stateObj.html || '';
          } catch (e) {
            console.error('Error al parsear el estado de paginación:', e);
          }
        }
        const scrollPos = this.storage.getItem('scrollPosition_' + this.routeKey);
        if (scrollPos) {
          setTimeout(() => {
            window.scrollTo(0, parseInt(scrollPos, 10));
          }, 100);
        }
        // Eliminamos el flag de preservación para que en próximas cargas se reinicie
        this.storage.removeItem('preservePagination_' + this.routeKey);
      } else {
        // No se ha hecho clic en producto, así que reiniciamos el estado para esta colección
        this.storage.removeItem('paginationState_' + this.routeKey);
        this.storage.removeItem('scrollPosition_' + this.routeKey);
        // Opcionalmente, se puede limpiar el contenido si se requiere
        // this.grid.innerHTML = '';
      }

      // Guardamos la posición del scroll mientras se navega
      window.addEventListener('scroll', this.handleScroll);

      // Si se hace clic en un producto, marcamos que se debe preservar el estado
      this.grid.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (link) {
          this.storage.setItem('preservePagination_' + this.routeKey, 'true');
        }
      });

      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
      this.storage.setItem('scrollPosition_' + this.routeKey, window.scrollY);
    }

    addUrlParam(search, key) {
      let newParam = key + '=' + this.i,
        params = '?' + newParam;
      if (search) {
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);
        if (params === search) {
          params += '&' + newParam;
        }
      }
      return params;
    }

    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }

    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].intersectionRatio === 1) {
            base.loadProducts();
          }
        },
        { threshold: [0, 1] }
      );
      base.observer.observe(base);
    }

    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');

      if (base.getAttribute('loading')) return;
      base.i++;
      base.setAttribute('loading', true);

      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          base.renderProducts(responseText, url);
          dispatchCustomEvent('pagination:page-changed', { url: url });
        });
    }

    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) base.button.classList.add('visually-hidden');
        return;
      }

      let products = grid_to_replace.querySelectorAll('.column');
      products.forEach((product) => base.grid.appendChild(product));

        try {
            this.storage.setItem(
                'paginationState_' + this.routeKey,
                JSON.stringify({
                    page: this.i,
                    html: this.grid.innerHTML,
                })
            );
        } catch (e) {
            if (e.name === "QuotaExceededError") {
                // Limpiar datos antiguos o mostrar alerta
                localStorage.removeItem('paginationState_' + this.routeKey);
                // Informar al usuario o almacenar menos datos
            }
        }

        if (this.animations_enabled) {
        gsap.set(products, { opacity: 0, y: 30 });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
          },
        });
      } else {
        base.removeAttribute('loading');
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
